<template>
  <nav class="blog-menu">
    <a
      v-for="item in blogMenu"
      :href="item.detailPage"
      :class="{ 'blog-menu__item_active': item.active }"
      class="blog-menu__item"
    >
      {{ item.name }}
    </a>
  </nav>
</template>

<script lang="ts" setup>
import { useResultsStore } from '@/storePinia/stores/results';
import { storeToRefs } from 'pinia';

const { blogMenu } = storeToRefs(useResultsStore());
</script>

<style lang="scss" scoped>
.blog-menu {
  display: grid;
  grid-row-gap: 24px;
  font-weight: 600;
  font-size: rem(12);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  @include point-md {
    display: flex;
    grid-area: menu;
    align-self: flex-start;
  }
  &__item {
    &:not(:last-child) {
      @include point-md {
        margin-right: 48px;
      }
    }
    &_active {
      text-decoration: underline;
      text-underline-position: under;
    }
  }
}
</style>
